module.exports = __webpack_public_path__ + "img/张海.2cd48738.jpg";